module.exports = __webpack_public_path__ + "static/media/SQL.ee5467ea.svg";